import { useQuery } from '@tanstack/react-query';

import { useUserQuery } from '@/features/users';

import { checkGoCardlessStatus } from '../api';
import { goCardlessQueryKeys } from '../data';

export const useCheckGoCardlessStatusQuery = () => {
  const user = useUserQuery();

  const query = useQuery({
    queryKey: [...goCardlessQueryKeys.checkStatus, user.data?.company_id],
    queryFn: () =>
      checkGoCardlessStatus({
        company_id: user.data?.company_id,
      }),
    enabled: Boolean(user.data?.company_id),
    retry: 0,
    refetchOnMount: true,
    staleTime: 0,
  });

  return query;
};
